export enum LEF_LEAD_KINDS {
  APK = 1,
  Tires = 2,
  Bid = 3,
  Brochure = 4,
  ContactRequest = 5,
  Financing = 6,
  Warranty = 7,
  KeepMePosted = 8,
  ClientSatisfaction = 9,
  Loyalty = 10,
  Mailing = 11,
  Quotation = 12,
  Maintenance = 13,
  PrivateLease = 14,
  TestDrive = 15,
  Repairs = 16,
  ShowroomVisit = 17,
  Taxation = 18,
  CallbackRequest = 19,
  Insurance = 20,
  OfficeQuotation = 21,
  OfficeAppointment = 22,
  CommercialLeasing = 23,
  Other = 24,
  ShortLease = 25,
  Rental = 26,
  Damage = 27,
  CarConfigurator = 28,
  Accessories = 29,
  Complaint = 30,
  Event = 31,
  TelephonicLead = 32,
  Webshop = 33,
  SearchRequest = 34,
  CallingList = 35,
  RecallCampaign = 36,
  ChargingPoint = 37
}
